export class ProductConfigOption {
  configoptionid: number;
  value: number;
}
